import React from 'react'
import Text from '../../Text'
import Image from '../../Image'
import { guidancePageContant } from '../../../config/pageContent'
import { medias } from '../../../config/Resources'

const Face13 = () => {
  return (
    <>
    <div>
        <div className='flex flex-col items-center mt-[41px] gap-[18px]'>
          <Text className='text-[54px] font-light'>Why there is nothing quite Like</Text>
          <Image src={medias.images.guidance.Face10.LogoBetween}
            alt="Logobetween"
            className='bg-[#F0BC5E] rounded-[11px] py-[18px] px-[33px]'
          />
        </div>
        <div className='grid grid-cols-2 gap-x-[142px] gap-y-[75px] px-[225px] py-[80px]'>
          {
            guidancePageContant.Face10.Perks.map(items => {
              return <div className='flex items-center gap-[18px] rounded-[17px] border border-[#707070] overflow-hidden' >
                <div className={`px-[11px] flex min-w-[148px] items-center h-full py-[13px] bg-[${items.back}]`}>
                  <Image src={items.img} className='' alt="Perk3" />
                </div>
                <div className='pl-[18px] py-[20px] pr-[38px] '>
                  <Text className='text-[27px] text-[#00114C] font-semibold'>{items.desc}</Text>
                </div>
              </div>
            })
          }

        </div>
      </div>
    
    </>
  )
}

export default Face13